<template>
  <div>
    <b-autocomplete
      icon="magnify"
      :data="dataAutoCompleteRemise"
      :loading="isLoading"
      field="libelle"
      v-model="inputValue"
      @select="remise => selectLibelleRemise(remise)"
      @input="getRemiseData"
      @focus="getRemiseData"
      open-on-focus>
      <template slot="header">
        <a @click="checkPermissions(permsRemise.maj)
          ? openPopUpAddEditLibelleRemise = true : showPopUp()"
          class="lien" :class="{ 'text-access-no-permission' :
            !checkPermissions(permsRemise.maj)}"
          v-show="hidePopUp">
          <span> {{ $t('listeRemise.actions.add')}} </span>
        </a>
      </template>
      <template slot="empty"> {{$t('listeRemise.actions.noResult')}} </template>
      <template slot-scope="props">
        {{ cgvs.length ? props.option.libelleRemise : props.option.libelle}}
      </template>
    </b-autocomplete>
    <b-modal v-model="openPopUpAddEditLibelleRemise"
          has-modal-card
          class="modal">
      <pop-up-add-edit-libelle-remise
        @reloadRemise="selectLibelleRemise">
      </pop-up-add-edit-libelle-remise>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { LIBELLE_REMISE } from '@/configuration/general/permissionsParametrageConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import popUpAddEditLibelleRemise from '@/components/parametrage/libelleRemise/p_addEditLibelleRemise';
import { sortBy } from 'lodash';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    hidePopUp: {
      type: Boolean,
      default: true,
    },
    cgvs: {
      type: Array,
      default: () => ([]),
    },
    lignesRemise: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    popUpAddEditLibelleRemise,
  },
  data() {
    return {
      openPopUpAddEditLibelleRemise: false,
      dataAutoCompleteRemise: [],
      permsRemise: LIBELLE_REMISE,
      inputValue: this.value,
      isLoading: false,
    };
  },
  watch: {
    value() {
      this.inputValue = this.value;
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    remises() {
      return this.parametre(PARAMETRES_KEYS.remise);
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    selectLibelleRemise(remise) {
      if (!remise) return;
      if (this.cgvs.length) this.$emit('is-select', remise);
      this.$emit('setRemiseRegie', remise.isRemiseRegie);
      this.inputValue = remise.message;
    },
    getRemiseData() {
      const filterFunc = (remise) => {
        if (this.inputValue === remise.libelle) {
          this.inputValue = remise.message;
          return this.$emit('input', this.inputValue);
        }
        this.$emit('input', this.inputValue);
        return remise.libelle.toLocaleLowerCase()
          .includes(this.inputValue.toLocaleLowerCase());
      };
      if (this.cgvs.length) {
        const remises = this.cgvs
          .map(cgv => ({
            ...cgv.libelleRemise,
            remise: cgv.remise,
            type: cgv.type,
            cgvId: cgv.id,
          }))
          .filter(filterFunc)
          .filter(remise => {
            return !this.lignesRemise.find(ligne => {
              return ligne.libelle === remise.message
                  && ligne.remise === remise.remise
                  && ligne.type === remise.type;
            });
          });
        remises.forEach(el => {
          el.libelleRemise = [el.libelle, el.type, `${el.remise}%`].join(' / ');
        });
        this.dataAutoCompleteRemise = sortBy(remises, [
          remise => remise.libelleRemise.toLowerCase(),
        ]);
      } else {
        this.dataAutoCompleteRemise = this.remises
          .filter(filterFunc)
          .filter(remise => {
            return !this.lignesRemise.find(ligne => {
              return ligne.libelle === remise.message;
            });
          });
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    try {
      this.inputValue = this.value;
      await this.loadParametres([PARAMETRES_KEYS.remise]);
      this.isLoading = false;
    } catch (e) {
      messageErreur(this.$i18n);
      this.isLoading = false;
      throw e;
    }
  },
};
</script>
